// Hover menu functionality for Baseline theme
(function() {
  'use strict';
  
  // Only run on desktop
  function isDesktop() {
    return window.innerWidth >= 1024;
  }
  
  function initHoverMenus() {
    if (!isDesktop()) return;
    
    // Find all menu items with dropdowns
    const menuWrappers = document.querySelectorAll('nav .no-js-focus-wrapper');
    
    menuWrappers.forEach(wrapper => {
      const button = wrapper.querySelector('button[aria-controls]');
      const dropdown = wrapper.querySelector('.no-js-focus-container');
      
      if (!button || !dropdown) return;
      
      let hoverTimeout;
      
      // Mouse enter on wrapper
      wrapper.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;
        
        clearTimeout(hoverTimeout);
        
        // Trigger Alpine.js to open
        const alpineData = Alpine.$data(wrapper);
        if (alpineData) {
          alpineData.expanded = true;
        }
      });
      
      // Mouse leave on wrapper
      wrapper.addEventListener('mouseleave', () => {
        if (!isDesktop()) return;
        
        // Add small delay before closing
        hoverTimeout = setTimeout(() => {
          const alpineData = Alpine.$data(wrapper);
          if (alpineData) {
            alpineData.expanded = false;
          }
        }, 100);
      });
      
      // Keep open when hovering dropdown
      dropdown.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;
        clearTimeout(hoverTimeout);
      });
      
      dropdown.addEventListener('mouseleave', () => {
        if (!isDesktop()) return;
        
        hoverTimeout = setTimeout(() => {
          const alpineData = Alpine.$data(wrapper);
          if (alpineData) {
            alpineData.expanded = false;
          }
        }, 100);
      });
    });
  }
  
  // Wait for Alpine.js to be ready
  document.addEventListener('alpine:init', () => {
    initHoverMenus();
  });
  
  // Fallback if Alpine is already loaded
  if (window.Alpine) {
    initHoverMenus();
  }
  
  // Re-initialize on window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initHoverMenus, 250);
  });
})();